import { Component } from "react";
import { Box, Button, Typography } from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import { COLORS } from "../theme";

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // Queda en la consola para diagnóstico — si esto se repite seguido,
    // revisa aquí primero (Network tab: ¿algún archivo .js dio 404? típico
    // después de un redeploy si el navegador tenía cacheado un index.html viejo).
    console.error("[ErrorBoundary]", error, info?.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        <Box
          sx={{
            minHeight: "100vh", display: "flex", flexDirection: "column",
            alignItems: "center", justifyContent: "center", gap: 2, p: 3,
            textAlign: "center", bgcolor: COLORS.paper,
          }}
        >
          <Typography variant="h6">Algo salió mal / Something went wrong</Typography>
          <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 380 }}>
            Intenta recargar la página. Si el problema sigue, avisa al administrador.
            <br />
            Try reloading the page. If it persists, tell your administrator.
          </Typography>
          <Button variant="contained" startIcon={<RefreshIcon />} onClick={() => window.location.reload()}>
            Recargar / Reload
          </Button>
        </Box>
      );
    }
    return this.props.children;
  }
}
